import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import { COLOR_MAP } from '../../../constants/ColorNames';


const SideBarSkeleton = () => {
    return (
        <Stack bgcolor={COLOR_MAP.WHITE} marginRight="1rem">
            <Card style={{ borderRadius: 0 }}>
                <CardHeader
                    title={
                        <Stack >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='50%'
                            />
                        </Stack>
                    }
                ></CardHeader>
                <CardContent style={{ paddingTop: 0 }}>
                    <Stack spacing={1}>
                        <Stack spacing={0.5} >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='30%'
                            />
                            <Skeleton variant="rectangular" height={30} />
                        </Stack>
                        <Stack spacing={0.5} >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='30%'
                            />
                            <Skeleton variant="rectangular" height={30} />
                            <Skeleton
                                animation="wave"
                                variant="text"
                            />
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
            <Card style={{ borderRadius: 0 }}>
                <CardHeader
                    title={
                        <Stack >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='50%'
                            />
                        </Stack>
                    }
                ></CardHeader>
                <CardContent style={{ paddingTop: 0 }}>
                    <Stack spacing={1}>
                        <Stack spacing={0.5} >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='30%'
                            />
                            <Skeleton variant="rectangular" height={30} />
                        </Stack>
                        <Stack spacing={0.5} >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='30%'
                            />
                            <Skeleton variant="rectangular" height={60} />
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>

            <Card style={{ borderRadius: 0 }}>
                <CardHeader
                    title={
                        <Stack >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='50%'
                            />
                        </Stack>
                    }
                ></CardHeader>
                <CardContent style={{ paddingTop: 0 }}>
                    <Stack spacing={1}>
                        <Stack spacing={0.5} >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='30%'
                            />
                            <Skeleton variant="rectangular" height={30} />
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='30%'
                            />
                        </Stack>
                        <Stack spacing={0.5} >
                            <Skeleton
                                animation="wave"
                                variant="text"
                                width='30%'
                            />
                            <Skeleton variant="rectangular" height={30} />
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    );
};

export default SideBarSkeleton;
